import styled from 'styled-components';

const MenuDivider = styled.div`
  max-width: 888px;
  width: calc(100vw - 32px);
  height: 1px;
  margin: 72px auto;
`;

export default MenuDivider;